export default {
  "HitPaw Online Audio Converter": "HitPaw Çevrimiçi Ses Dönüştürücü",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "Sesleri MP3, AAC, FLAC, WMA ve daha birçok biçime ücretsiz olarak dönüştürün.",
  'HitPaw Online Image Converter': 'HitPaw Çevrimiçi Görüntü Dönüştürücü',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': 'Görüntüleri JPG, PNG, BMP, TIFF ve daha birçok biçime ücretsiz olarak dönüştürün.',
  'HitPaw Online Video Converter': 'HitPaw Çevrimiçi Video Dönüştürücü',
  'Convert videos to any formats as your requirements.': 'Videoları gereksinimlerinize göre herhangi bir biçime dönüştürün',
  'Add More Files': 'Daha Fazla Dosya Ekle',
  'Convert to': 'Dönüştürmek için',
  'Ready': 'Hazır',
  'Converting': 'Dönüştürülüyor',
  'Video': 'Video',
  'Audio': 'Ses',
  'Image': 'Görüntü',
  'Retry': 'Yeniden dene',
  'Download All': 'Tümünü İndir',
  'Download Desktop': 'Masaüstünü İndir',
  'Continue Editing': 'Düzenlemeye Devam Et',
  'Convert': 'Dönüştür',
  'Cut': 'Kes',
  'Speed': 'Hız',
  'Crop & Rotate': 'Kırp ve Döndür',
  'Resize': 'Boyutlandır',
  'Extract': 'Çıkar',
  'Add Music': 'Müzik ekle',
  'Subtitles': 'Altyazılar',
  'Merge': 'Birleştir',
  'Watermark Remover': 'Filigran Kaldırıcı',
  'Add Watermark': 'Filigran ekle',
  'Please select a file to use': 'Lütfen {{work}} kullanmak için bir dosya seçin',
  'Batch Processing': 'Batch Processing',
};
